import { forwardRef, type HTMLAttributes } from "react";

export type NcTextHiddenProps = Omit<HTMLAttributes<HTMLInputElement>, "type">;

export const NcTextHidden = forwardRef<HTMLInputElement, NcTextHiddenProps>(({ ...props }, ref) => (
  <input type="hidden" data-nc="NcTextHidden" ref={ref} {...props} />
));
